var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scratchCard",style:('width:'+_vm.width+';height:'+_vm.height+';'),attrs:{"id":_vm.elementId}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLucky),expression:"showLucky"}],staticClass:"result"},[_vm._t("result"),_vm._v(" "),_c('div',{staticClass:"pic",domProps:{"innerHTML":_vm._s(_vm.result)}})],2),_vm._v(" "),_c('canvas',{attrs:{"id":"scratchCanvas"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e57088","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myPlugin/scratchCard/scratchCard.vue
// module id = 9
// module chunks = 0